module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"welcome":"Welcome, {0}"},"es":{"welcome":"Bienvenido, {0}"}}')
  delete Component.options._Ctor
}
